import React, { FC, useContext } from 'react';
import { SupplierOrderContext } from 'pages/order-flow/supplier-order/supplier-order-context';
import SimpleRestorations from 'components/order-flow/shared/constructions/simple-restorations.component';

type ConstructionProps = {
    disableEdit?: boolean;
};
const Constructions: FC<ConstructionProps> = ({ disableEdit }) => {
    const { order, updateOrder } = useContext(SupplierOrderContext);
    return (
        <SimpleRestorations
            restorations={order.restorations}
            onChange={(restorations) => updateOrder({ ...order, restorations })}
            disableEdit={disableEdit}
        />
    );
};

export default Constructions;
